<script lang="ts">
    import type {UserAccountReactivePageData, UserAccountStaticPageData} from '../../types';
    import {getLocalization} from 'core/svelte-context/context';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpPopover from 'shared/ui-widgets/popover/KpPopover.svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import UserAccountEditButtons from '../../components/UserAccountEditButtons.svelte';

    export let fromRecordDetail = false;

    const localize = getLocalization();

    const pageContext = getPageContext<UserAccountStaticPageData, UserAccountReactivePageData>();
    const user = pageContext.staticData.user;
    const detailView = pageContext.staticData.detailView;
</script>

<KpPopover buttonSize="md"
           placement="bottom-end"
           buttonStyle="default"
           additionalPopoverClasses="sutor-user-account-settings-popover"
           additionalPopoverPanelClasses="sutor-user-account-settings-popover-panel"
           additionalClasses="sutor-user-account-settings-button">

    <UIcon slot="button" icon="{fromRecordDetail ? 'user' : 'settings'}"/>
    <span slot="popover-title">
        {localize(/* @kp-localization konto.UserManagement */ 'konto.UserManagement')}
    </span>

    <div slot="popover-content" class="sutor-user-account-settings-popover-content">
        <UserAccountEditButtons {user} {detailView}/>
    </div>
</KpPopover>

<style lang="less">
    @import (reference) "styles/portaro.themes.less";
    @import (reference) "styles/portaro.variables.less";

    .sutor-user-account-settings-popover-content {
        padding: @spacing-s 0;
        display: flex;
        flex-direction: column;
        gap: @spacing-m;
    }

    :global {
        .sutor-user-account-settings-popover {
            .popover {
                background-color: @themed-body-bg;
            }

            .popover {
                border-radius: @border-radius-large;
                border: 1px solid var(--viewer-default-border);

                .popover-title {
                    display: flex;
                    align-items: center;
                    height: 42px;
                    background-color: @themed-body-bg;
                    border-bottom: 1px solid @themed-border-default;
                    border-radius: 0;
                    font-weight: 500;
                }

                .popover-content {
                    background-color: transparent;
                    padding: @spacing-m @spacing-ml;
                }
            }
        }

        .sutor-user-account-settings-popover-panel {
            width: 300px;
            margin-top: @spacing-s !important;
            margin-left: calc(@spacing-m * -1) !important;
        }
    }
</style>